import { api } from '@/lib/axios';

export type WbElement =
  | { id: string; type: 'path'; points: { x: number; y: number }[]; color: string; width: number }
  | { id: string; type: 'rect'; x: number; y: number; w: number; h: number; color: string }
  | { id: string; type: 'ellipse'; x: number; y: number; w: number; h: number; color: string }
  | { id: string; type: 'text'; x: number; y: number; text: string; color: string; size: number }
  | { id: string; type: 'note'; x: number; y: number; w: number; h: number; text: string; color: string };

export const whiteboardApi = {
  async get(meetingId: string): Promise<WbElement[]> {
    const { data } = await api.get(`/whiteboard/${meetingId}`);
    return (data.data.whiteboard.scene as WbElement[]) ?? [];
  },
  async save(meetingId: string, scene: WbElement[]): Promise<void> {
    await api.put(`/whiteboard/${meetingId}`, { scene });
  },
};
